<p-scrollPanel [style]="{ width: '100%', height: 'calc(100% - 76px)' }">
    <div class="grid p-3 w-full h-full">
        <ng-container *ngFor="let question of questions; index as index">
            <p-card class="m-3 w-full">
                <ng-template pTemplate="title">
                    <div *ngIf="question.questionId !== selectedQuestion?.questionId" class="p-card-title">{{question.title}}</div>
                    <input *ngIf="question.questionId === selectedQuestion?.questionId" pInputText type="text" class="p-inputtext-lg w-full" placeholder="Titolo" [(ngModel)]="question.title" />
                </ng-template>
                <ng-template pTemplate="subtitle">
                    <div *ngIf="question.questionId !== selectedQuestion?.questionId" class="p-card-subtitle"><h2>{{question.description}}</h2></div>
                    <div *ngIf="question.questionId === selectedQuestion?.questionId" class="p-card-subtitle">
                        <input *ngIf="question.questionId === selectedQuestion?.questionId" pInputText type="text" class="p-inputtext-md w-full" placeholder="Domanda" [(ngModel)]="question.description" /></div>
                    
                </ng-template>
                <div>
                    <p-button [disabled]="question.questionId !== selectedQuestion?.questionId" (click)="modifyAuthorizedUsers(index)" icon="pi pi-external-link" label="Utenti"></p-button>
                </div>
                <div class="shadow-1 mt-3 p-2 surface-card">
                    <div class="mt-3">
                        <span>
                            Valido da:
                        </span>
                        <span *ngIf="question.questionId !== selectedQuestion?.questionId">
                            {{question.startTime | date: 'yyyy-MM-dd HH:mm'}}
                        </span>
                        <p-calendar [touchUI]="true" dateFormat="yy-mm-dd" *ngIf="question.questionId === selectedQuestion?.questionId" [disabled]="question.questionId !== selectedQuestion?.questionId" [(ngModel)]="question.startTime" [showTime]="true"></p-calendar>
                    </div>
                    <div class="mb-3 mt-3">
                        <span>
                            Fino a:
                        </span>
                        <span *ngIf="question.questionId !== selectedQuestion?.questionId">
                            {{question.endTime | date: 'yyyy-MM-dd HH:mm'}}
                        </span>
                        <p-calendar [touchUI]="true" dateFormat="yy-mm-dd" *ngIf="question.questionId === selectedQuestion?.questionId" [disabled]="question.questionId !== selectedQuestion?.questionId" [(ngModel)]="question.endTime" [showTime]="true"></p-calendar>
                    </div>
                </div>
                <div class="shadow-1 mt-3 p-2 surface-card">
                    <div class="mt-3" *ngIf="question.questionId !== selectedQuestion?.questionId">
                        <span>Numero minimo di risposte: {{question.minResponses}}</span><br>
                        <span>Numero massimo di risposte: {{question.maxResponses}}</span>
                    </div>
                    <div class="flex-auto" *ngIf="question.questionId === selectedQuestion?.questionId">
                        <label for="integeronly">Numero minimo di risposte</label>
                        <p-inputNumber inputId="integeronly" class="p-inputtext-md w-full" placeholder="Numero minimo di risposte" [(ngModel)]="question.minResponses" />
                    </div>
                    <div class="flex-auto" *ngIf="question.questionId === selectedQuestion?.questionId">
                        <label for="integeronly">Numero massimo di risposte</label>
                        <p-inputNumber inputId="integeronly" class="p-inputtext-md w-full" placeholder="Numero massimo di risposte" [(ngModel)]="question.maxResponses" />
                    </div>
                    <div class="mt-3">
                        <p-toggleButton class="mr-2" [(ngModel)]="question.hasWhite" onLabel="Scheda bianca: Si" (ngModelChange)="onWhiteLabelChange(index, $event)" offLabel="Scheda bianca: No" [disabled]="question.questionId !== selectedQuestion?.questionId"></p-toggleButton>
                    </div>
                    <div class="mt-3">
                        <ng-container *ngFor="let pVote of question.possibleVotes | sort; index as voteIdx; count as count">
                            <div class=" mb-3">
                                <span class="mr-3" *ngIf="question.questionId !== selectedQuestion?.questionId || pVote.isWhite">Voto {{voteIdx + 1}}: {{pVote.answer}}</span>
                                <input 
                                    *ngIf="question.questionId === selectedQuestion?.questionId && !pVote.isWhite" 
                                    pInputText 
                                    type="text" 
                                    class="mr-3 p-inputtext-md" 
                                    placeholder="Risposta" 
                                    [(ngModel)]="pVote.answer" />
                                <p-button class="w-3rem" *ngIf="question.questionId === selectedQuestion?.questionId && !pVote.isWhite" [outlined]="true" (onClick)="removeAnswer(index, voteIdx)" icon="pi pi-minus-circle" label="Rimuovi"></p-button>
                            </div>
                        </ng-container>
                        <div class="mb-3" *ngIf="question.questionId === selectedQuestion?.questionId">
                            <p-button [outlined]="true" (onClick)="addNewAnswer(index, blankTemplate(question.possibleVotes.length + 1), question.possibleVotes.length)" label="Aggiungi risposta" icon="pi pi-plus-circle"></p-button>
                        </div>
                    </div>
                </div>
                <ng-template pTemplate="footer">
                    <p-button *ngIf="question.questionId !== selectedQuestion?.questionId" label="Elimina" (onClick)="removeQuestion(question, index)" icon="pi pi-times" severity="danger" [style]="{ 'margin-left': '.5em' }"></p-button>
                    <p-button *ngIf="question.questionId === selectedQuestion?.questionId" label="Salva" (onClick)="showConfirm(question, index)" icon="pi pi-save" severity="success"></p-button>
                    <p-button *ngIf="question.questionId === selectedQuestion?.questionId" label="Annulla" (onClick)="cancel(index)" icon="pi pi-times" severity="danger" [style]="{ 'margin-left': '.5em' }"></p-button>
                    <p-button [disabled]="question.voteResults?.length === 0" label="Risultati" (onClick)="showVotes(question)" icon="pi pi-check-square" severity="info" [style]="{ 'margin-left': '.5em' }"></p-button>
                </ng-template>
            </p-card>
        </ng-container>
    </div>
</p-scrollPanel>
<p-speedDial [model]="items" showIcon="pi pi-chevron-up" hideIcon="pi pi-chevron-down" direction="up" type="linear"></p-speedDial>


<p-dialog class="w-min" [(visible)]="isVoteVisible" *ngIf="selectedQuestion !== null" [closeOnEscape]="false" [closable]="false" [modal]="true" [draggable]="false">
    <ng-template pTemplate="header">
        <h2>{{selectedQuestion.title}}</h2>
    </ng-template>
    <p>
        Risultati: 
    </p>
    <ul>
        <li *ngFor="let res of selectedQuestion.voteResults">
            <span>{{res.vote.answer}}</span>: <span>{{res.total}}</span>
        </li>
    </ul>
    <p>
        Votanti: 
    </p>
    <ul>
        <li *ngFor="let res of selectedQuestion.authorizations">
            <span>{{res.subscriber.name}} {{res.subscriber.lastName}}</span>
            <i [style]="{'color': res.hasVoted ? '#00BB00' : '#BB0000'}"> ({{res.hasVoted? 'Ha votato': 'Voto mancante'}})</i>
        </li>
    </ul>
    <p>
        Voti effettivi: 
    </p>
    <ul *ngIf="isVoteVisible">
        <li *ngFor="let res of selectedQuestion.authorizations">
            <span>{{res.subscriber.name}} {{res.subscriber.lastName}}:</span><i> {{getVotes(res.signId)}}</i>
        </li>
    </ul>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="hideVotes()" label="Presa visione" severity="primary" [outlined]="true"></p-button>
    </ng-template>
</p-dialog>


<p-dialog class="w-min" [(visible)]="isConfirmation" *ngIf="selectedQuestion !== null" [closeOnEscape]="false" [closable]="false" [modal]="true" [draggable]="false">
    <ng-template pTemplate="header">
        <h2>{{selectedQuestion.title}}</h2>
    </ng-template>
    <div>
        <p>
            Numero di utenti selezionati: {{selectedQuestion.authorizations !== undefined? selectedQuestion.authorizations.length: 0}}
        </p>
    </div>
    <div>
        <p>
            Numero totale voti: {{selectedQuestion.possibleVotes.length}}
        </p>
    </div>
    <div>
        <p>
            Valida dal {{selectedQuestion.startTime | date: 'yyyy-MM-dd HH:mm'}}
            al {{selectedQuestion.endTime | date: 'yyyy-MM-dd HH:mm'}}
        </p>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-times" (click)="hideConfirm()" label="Annulla" severity="primary" severity="danger" [outlined]="true"></p-button>
        <p-button icon="pi pi-check" (click)="modifyQuestion(editIndex)" label="Conferma" severity="primary" severity="confirm" [outlined]="true"></p-button>
    </ng-template>
</p-dialog>